import { LocalizationService } from '@abp/ng.core';
import { Component, inject, OnInit } from '@angular/core';
import { LoadingService } from '../services';
import { NgSelectConfig } from '@ng-select/ng-select';
import { debounceTime, delay } from 'rxjs';

@Component({
  template: '',
})
export abstract class BaseAppComponent implements OnInit {
  protected ngSelectConfig = inject(NgSelectConfig);
  protected localizationService = inject(LocalizationService);
  protected loadingService = inject(LoadingService);

  protected loading: boolean = false;

  constructor() {
    this.ngSelectConfig.appendTo = 'body';
    this.ngSelectConfig.notFoundText = this.localizationService.instant('Core::NoItems');
    this.ngSelectConfig.loadingText = this.localizationService.instant('Core::Loading');
    this.ngSelectConfig.clearAllText = this.localizationService.instant('Core::ClearAll');
    this.ngSelectConfig.typeToSearchText = this.localizationService.instant('Core::TypeToSearch');
  }

  ngOnInit() {
    this.listenToLoading();
  }

  protected listenToLoading(delayTime: number = 50): void {
    this.loadingService.loadingSub.pipe(delay(0), debounceTime(delayTime)).subscribe(loading => {
      this.loading = loading;
    });
  }
}
